module.exports = __webpack_public_path__ + "6042-shadow.b8b560f9522036f26359657614c112f8.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/6042-shadow.png
// module id = 487
// module chunks = 0